<template>
  <div
    style="min-height: 100vh;"
    class="background-white"
  >
    <AppHeader
      :title="$store.state.language === 'en' ? 'Settings' : 'ဆက်တင်များ'"
      :showBack="true"
      :has-actions="true"
    />
    <div class="d-flex flex-column main-wrapper px-3">
      <div
        class="d-flex align-items-center my-3"
        style="gap: 15px;"
      >
        <img
          src="@/assets/images/user_img.png"
          alt="User"
          width="70"
          height="70"
        >
        <div>
          <h3 style="font-size: 16px;">နာမည်: {{ $store.state.authUser.name }}</h3>
          <h4
            class="mb-0"
            style="font-size: 14px;"
          >ဖုန်း: {{ $store.state.authUser.phone ?? '-' }}</h4>
        </div>
      </div>

      <div class="bg-success text-white rounded-lg mt-2 p-4 d-flex align-items-stretch">
        <!-- Withdraw Section -->
        <div class="half-section text-center d-flex flex-column justify-content-center">
          <p class="mb-1 font-weight-bold">
            {{ Number($store.state.totalWithdraw ?? 0).toLocaleString() }}
            {{ $store.state.language === 'en' ? 'MMK' : 'ကျပ်' }}
          </p>
          <p class="mb-0">
            {{ $store.state.language === "en" ? "Withdraw" : "ငွေထုတ်" }}
          </p>
        </div>

        <!-- Separator -->
        <div class="vertical-separator"></div>

        <!-- Balance Section -->
        <div class="half-section text-center d-flex flex-column justify-content-center">
          <p class="mb-1 font-weight-bold">
            {{ Number($store.state.amount ?? 0).toLocaleString() }}
            {{ $store.state.language === 'en' ? 'MMK' : 'ကျပ်' }}
          </p>
          <p class="mb-0">
            {{ $store.state.language === "en" ? "Balance" : "လက်ကျန်ငွေ" }}
          </p>
        </div>
      </div>

      <div class="my-4">
        <SettingMenu
          :label="$store.state.language === 'en'
            ? `Nick Name - ${$store.state.authUser.user_name || ''}`
            : `Nick Name - ${$store.state.authUser.user_name || ''}`
            "
          iconClass="fas fa-user"
        />
        <SettingMenu
          :label="$store.state.language === 'en'
            ? 'Change Password'
            : 'လျှို့ဝှက်နံပါတ် ပြောင်းမည်'
            "
          iconClass="fas fa-key"
          data-toggle="modal"
          data-target="#editUserPassword"
        />
        <SettingMenu
          :label="$store.state.language === 'en'
            ? 'Rules'
            : 'စည်းကမ်းချက်များ'
            "
          iconClass="fas fa-book"
          @click="() => $router.push('/rule')"
        />
        <SettingMenu
          :label="$store.state.language === 'en'
            ? 'Change Language'
            : 'ဘာသာစကား ပြောင်းမည်'
            "
          id="navbar-language"
          iconClass="fas fa-language"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        />
        <div
          class="dropdown-menu dropdown-menu-right"
          aria-labelledby="navbar-language"
        >
          <a
            class="dropdown-item"
            @click="setLangLocalstorage('en')"
          ><img
              src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/united-kingdom.png"
              alt=""
              class="mr-2"
              style="width: 20px; height: 20px"
            />
            {{
              $store.state.language === 'en' ? 'English' : 'အဂ်လိပ်စာ'
            }}</a>
          <div class="dropdown-divider"></div>
          <a
            class="dropdown-item"
            @click="setLangLocalstorage('mm')"
          ><img
              src="https://cdn.myanmarsoccer.xyz/build/assets/img/icons/common/myanmar.png"
              alt=""
              class="mr-2"
              style="width: 20px; height: 20px"
            />{{
              $store.state.language === 'en'
                ? 'Myanmar (Burmese)'
                : 'မြန်မာ (ဗမာစာ)'
            }}</a>
        </div>
      </div>


      <button
        class="btn custom-button py-3"
        @click="logout()"
      >
        <img
          src="https://cdn.gold549.com/build/assets/img/theme/logout.png"
          alt="Logout"
          style="width: 20px; height: 20px"
          class="mr-3"
        />
        <span class="nav-link-text">{{
          $store.state.language === 'en' ? 'Log Out' : 'ထွက်မည်'
        }}</span>
      </button>

      <!-- ==== modal for user password edit ==== -->
      <div
        class="modal fade"
        id="editUserPassword"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered modal-sm"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body">
              <div class="card border-0 mb-0">
                <div class="card-body px-lg-5 py-lg-5">
                  <div class="form-group">
                    {{
                      $store.state.language === 'en'
                        ? 'Old Password'
                        : 'လျို့ဝှက်နံပါတ်အဟောင်း။'
                    }}
                    <div class="mt-2 input-group">
                      <input
                        class="form-control"
                        v-model="password.old"
                      />
                    </div>
                    <span class="text-danger">{{ errors.old }}</span>
                  </div>
                  <div class="form-group">
                    {{
                      $store.state.language === 'en'
                        ? 'New Password'
                        : 'လျို့ဝှက်နံပါတ်အသစ်။'
                    }}
                    <div class="mt-2 input-group">
                      <input
                        class="form-control"
                        v-model="password.new"
                      />
                    </div>
                    <span class="text-danger">{{ errors.new }}</span>
                  </div>
                  <div class="form-group">
                    {{
                      $store.state.language === 'en'
                        ? 'Confirm Password'
                        : 'အတည်ပြုလျို့ဝှက်နံပါတ်။'
                    }}
                    <div class="mt-2 input-group">
                      <input
                        class="form-control"
                        v-model="password.confirm"
                      />
                    </div>
                    <span class="text-danger">{{
                      errors.confirm || errors.confirmPassword
                    }}</span>
                  </div>
                  <div class="text-center">
                    <button
                      type="button"
                      class="btn custom-button"
                      @click="changeNewPassword"
                    >
                      <div v-if="!isConfirm">
                        {{
                          $store.state.language === 'en'
                            ? 'Confirm'
                            : 'အတည်ပြုမည်'
                        }}
                      </div>

                      <Loading
                        color="#ffffff"
                        v-if="isConfirm"
                        size="24"
                        class="px-4 py-0"
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from '@/components/AppHeader.vue';
import ProfileCard from '@/components/ProfileCard.vue';
import SettingMenu from '@/components/SettingMenu.vue';
import { Toast, Dialog, Loading } from 'vant';
import { mapActions } from 'vuex';

export default {
  components: { Loading, AppHeader, ProfileCard, SettingMenu },
  data() {
    return {
      password: {
        user_id: this.$store.state.authUser.id,
      },
      isConfirm: false,
      errors: {},
    };
  },
  methods: {
    ...mapActions(['logoutUser', 'fetchUser']),
    setLangLocalstorage(language) {
      localStorage.setItem('language', language);
      this.$store.commit('setLanguage', language);
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === 'en'
            ? 'Old password required'
            : 'လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။';
        return false;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === 'en'
            ? 'New password required'
            : 'လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။';
        return false;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === 'en'
            ? 'Confirm password required'
            : 'အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။';
        return false;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === 'en'
            ? 'New passwords not match'
            : 'လျှို့ဝှက်နံပါတ် မတူညီပါ။';
        return false;
      }
      this.isConfirm = true;
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure?'
            : 'သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မလုပ်တော့ပါ။',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ။',
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => { });
      this.isConfirm = false;
      return true;
    },
    async updateUser() {
      try {
        const res = await axios.post(
          '/auth/userPasswordChange',
          this.password,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        Toast.success(
          this.$store.state.language === 'en' ? 'Success' : 'အောင်မြင်သည်။'
        );
        this.password = {};
        this.errors = {};
        $('#editUserPassword').modal('hide');
      } catch (error) {
        Toast.fail(
          this.$store.state.language === 'en' ? 'Fail' : 'ကျရှုံးသည်။'
        );
      }
    },
    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
  },
};
</script>
<style scoped>
.nav-link-text {
  font-weight: bold;
}

.css-17h40hp {
  margin: 0px;
  line-height: 1.5;
  font-size: 14px;
  /* font-family: NotoSansMyanmar; */
  font-weight: 700 !important;
}

.error {
  margin-bottom: 13px;
  height: 40px;
  display: flex;
  align-items: center;
  color: red;
  border: 1px solid red;
  border-radius: 8px;
  padding: 0px 15px;
  background: #ff000014;
  font-weight: bold;
}

.half-section {
  flex: 1;
}

.vertical-separator {
  width: 1px;
  background-color: rgba(255, 255, 255, 0.5);
  margin: 0 15px;
}
</style>
